// Copyright 2023 Anthony Howell. All rights reserved.
// App.tsx
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import './App.scss';
import ViewModel from './core/ViewModel';
import MainView from './MainView';

const viewModel = new ViewModel();

function App() {
  return (
    <Router>
      <Routes>
        <Route
          path="/:gameType?/:numberOfPlayers?/:numberOfSimulations?"
          element={<MainView viewModel={viewModel} />}
        />
      </Routes>
    </Router>
  );
}

export default App;
